<template>
  <div style="width: 100%">
    <div class="login-input">
      <input
        v-model="loginName"
        placeholder="请设置登录账号，仅限字母、数字，例如“huawei001”"
        @keyup="checkInput('loginName')"
        maxlength="30"
      />
      <span class="login-err" v-show="loginNameErr">{{
        loginName.length == 0
          ? "登录账号不能为空"
          : "登录账号只能由字母、数字组成"
      }}</span>
      <span class="login-input-length">{{ loginName.length }}/30</span>
    </div>
    <div class="login-input">
      <input
        v-model="mobile"
        placeholder="请输入手机号"
        @keyup="checkInput('mobile')"
        maxlength="11"
      />
      <span class="login-err" v-show="mobileErr">手机号格式不正确</span>
      <span class="login-input-length">{{ mobile.length }}/11</span>
    </div>
    <div class="login-input">
      <input
        v-model="password"
        type="password"
        placeholder="由8-16位数字、字母、符号中的俩种或以上组成"
        @keyup="checkInput('password')"
        maxlength="20"
      />
      <span class="login-err" v-show="passwordErr"
        >字母/数字/特殊字符(~!@#$%^&*()_.)中至少两种组成，8-16位</span
      >
      <span class="login-input-length">{{ password.length }}/16</span>
    </div>
    <div class="login-input">
      <input
        v-model="confirmPswd"
        type="password"
        placeholder="请确认密码"
        @keyup="checkInput('confirmPswd')"
        maxlength="20"
      />
      <span class="login-err" v-show="confirmPswdErr">俩次密码不一致</span>
      <span class="login-input-length">{{ confirmPswd.length }}/16</span>
    </div>

    <div class="login-input flexStart">
      <input
        v-model="code"
        placeholder="请输入短信验证码"
        @keyup.enter="login"
        @blur="checkInput('code')"
        maxlength="6"
        style="flex: 1; margin-right: 30px"
      />
      <div>
        <button-load
          @clickHandle="getInviteCode"
          type="primary"
          :disabled="countDisabled"
          :lable="btnLabel"
        ></button-load>
      </div>
      <span class="login-err" v-show="codeErr && code.length != 6">{{
        code.length == 0 ? "验证码不能为空" : "请输入6位验证码"
      }}</span>
      <span class="login-input-length" style="right: 156px">{{ code.length }}/6</span>
    </div>
    <div class="login-input">
      <a-checkbox v-model="isAgree" style="color: #1890ff">同意</a-checkbox>
      <a @click="showModal" style="color: #999">《告知书》</a>
           <a @click="showPrivacyModal" style="color:#999;">《隐私协议》</a>
           <a @click="showUserAgreementModal" style="color:#999;">《用户使用协议》</a>
    </div>
    <span class="text-color-red text-size-12" style="position: absolute">{{
      errMsg
    }}</span>
    <div class="login-btn-box">
      <a-button
        :loading="loadLogin"
        type="primary"
        @click="checkRegister"
        class="login-btn"
        :disabled="!checkInput()"
        >注册</a-button
      >
      <div class="login-register"><span @click="toRegister">登 录</span></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { getCaptcha, savePersonInf } from "@/api/register";
import { JSEncrypt } from "jsencrypt";
export default {
  data() {
    return {
      encrypt: new JSEncrypt(),
      pubKey:"MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCJs93/+qTGnMr68IZoEZjmwlkiJ5lhD+HE6GQMiu/giAjCthA2G8+ri679/FmsryLXqUOEUSYBVmkl2gjmD8XhgYx9BEfO00qhz5uvnhTLNN4RKha8Epsx07EqTm6+LWYdFwuf4MIlKVy3B1YZN9qamyWelXoiDILtf78vFLvnOQIDAQAB",
      loginName: "",
      mobile: "",
      password: "",
      confirmPswd: "",
      code: "",
      loginNameErr: false,
      mobileErr: false,
      passwordErr: false,
      confirmPswdErr: false,
      codeErr: false,

      modalShow: false,
      loadLogin: false,
      isAgree: false,
      counter: 0,
      countDisabled: false,
      errMsg: "",
      btnLabel:'获取验证码'
    };
  },
  computed: {},
  methods: {
    ...mapMutations({
      setUserObj: "home/setUserObj",
    }),
    checkInput(type) {
      switch (type) {
        case "loginName":
          this.loginNameErr =
            this.loginName.length == 0 ||
            !this.utils.regExpObj.ALPHABET_NUMBER_PATTERN.test(this.loginName);
          break;
        case "mobile":
          this.mobileErr =
            this.mobile.length == 0 ||
            !this.utils.regExpObj.MOBILE_PATTERN.test(this.mobile);
          break;
        case "password":
          this.passwordErr =
            this.password.length == 0 ||
            !this.utils.regExpObj.PASSWORD_PATTERN.test(this.password);
          break;
        case "confirmPswd":
          this.confirmPswdErr =
            this.confirmPswd.length == 0 || this.password !== this.confirmPswd;
          break;
        case "code":
          this.codeErr = this.code.length != 6;
          break;
        default:
          return (
            this.loginName.length > 0 &&
            this.utils.regExpObj.ALPHABET_NUMBER_PATTERN.test(this.loginName) &&
            this.utils.regExpObj.MOBILE_PATTERN.test(this.mobile) &&
            this.utils.regExpObj.PASSWORD_PATTERN.test(this.password) &&
            this.password === this.confirmPswd &&
            this.code.length == 6 &&
            this.isAgree
          );
      }
    },
    countTimmer(init) {
      if (init) {
        this.countDisabled = true;
        this.counter = 60;
      }
      if (this.counter > 0) {
        setTimeout(() => {
          this.counter--;
          this.btnLabel = `${this.counter}s后重新获取`
          this.countTimmer();
        }, 1000);
      } else {
        this.btnLabel = `重新获取`
        this.countDisabled = false;
      }
    },
    getInviteCode(btn) {
      this.checkInput("mobile");
      if (!this.mobileErr) {
        const param = {
          target: this.mobile,
          mode: "SMS",
          type: "reg",
        };
        getCaptcha(param)
          .then((res) => {
            this.$message.success("验证码已发送");
            this.countTimmer(true);
            btn.closeLoad();
          })
          .catch((err) => {
            this.errMsg = err.description;
            btn.closeLoad();
          });
      } else {
        btn.closeLoad();
      }
    },
    checkRegister() {
      this.loadLogin = true;
      this.encrypt.setPublicKey(this.pubKey);
      const json = {
        code:this.code,
        password:this.encrypt.encrypt(this.password),
        confirmPswd:this.encrypt.encrypt(this.confirmPswd),
        jfCode:'reg',
        ctrFlag:true,
        loginName:this.loginName,
        mobile:this.mobile
      };
      savePersonInf(json)
        .then((res) => {
          this.$message.success("注册成功");
          this.loadLogin = false;
          this.$router.replace('/login')
        })
        .catch((err) => {
          this.loadLogin = false;
          this.errMsg = err.description;
        });
    },
    showModal() {
      this.$parent.showModal();
    },
    showPrivacyModal() {
      this.$parent.showPrivacyModal();
    },
    showUserAgreementModal() {
      this.$parent.showUserAgreementModal();
    },
    modalCancel(e) {
      this.modalShow = false;
    },
    toRegister() {
      this.$router.push("/login");
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
footer {
  position: absolute;
  bottom: 0;
  line-height: 40px;
  width: 100%;
  color: #fff;
  background: rgba(0, 0, 0, 0.3);
}
.footer-text {
  width: 80%;
  margin: 0 auto;
}
.login-input {
  margin: 20px 0 0;
  line-height: 40px;
  position: relative;
}
.step-2 .login-input {
  margin: 20px 0 0;
  line-height: 40px;
  position: relative;
}
.login-err {
  position: absolute;
  color: red;
  left: 0;
  bottom: -32px;
  font-size: 12px;
  transition: all ease 0.4s;
}
.login-input input {
  width: 100%;
  border: none;
  outline: none;
  border-bottom: 1px solid #ddd;
  line-height: 40px;
  height: 40px;
}
.login-input input:focus {
  border-color: #1990ff;
  transition: border-color 0.5s ease;
  -moz-transition: border-color 0.5s ease; /* Firefox 4 */
  -webkit-transition: border-color 0.5s ease; /* Safari 和 Chrome */
  -o-transition: border-color 0.5s ease;
}
.login-input-focus::after {
  content: "";
  display: inline-block;
  width: 100%;
  height: 1px;
  background-color: #1990ff;
  transition: all 0.5s ease;
}
.login-btn-box {
  margin-top: 16px;
  font-size: 14px;
}
.login-btn {
  width: 100%;
  border: none;
  height: 44px;
  font-size: 18px;
}
.login-register {
  color: #1890ff;
  cursor: pointer;
  text-align: center;
  margin-top: 20px;
}
.login-forget {
  color: #999;
  text-decoration: underline;
  cursor: pointer;
}
.login-input-length {
  position: absolute;
  top: 6px;
  right: 20px;
  color: #d8d8d8;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components-frame/register-person.vue